import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const checkDuplicatePreClaim = createProvider(api.checkDuplicatePreClaim)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
